
import ActivityBlog from '@/components/ActivityBlog/ActivityBlog'
import PlaceCard from '@/components/PlaceCard'
import PlaceCardv2 from '@/components/PlaceCardv2'
import locationModal from '@/components/modals/locationModal.vue';
import RentalCard from '@/components/RentalCard'
import SectionLoader from '@/components/SectionLoader'
import PremiumCoupon from '@/components/PremiumCoupon.vue'
import FilterCard from '@/components/FilterCard.vue';
import ShimmerEffect from "@/components/ShimmerEffect.vue";
import EventCardGeneral from '@/components/EventCardGeneral.vue';
import BannerSliderItem from '@/components/BannerSliderItem.vue';
import MainCategoryCard from "@/components/MainCategoryCard.vue";
import ActivityCard from "@/components/ActivityCard.vue";
export default {
  scrollToTop: true,
  layout: 'home',
  components: {
    BannerSliderItem,
    MainCategoryCard,
    ActivityBlog,
    PlaceCard,
    PlaceCardv2,
    locationModal,
    RentalCard,
    SectionLoader,
    PremiumCoupon,
    FilterCard,
    ShimmerEffect,
    EventCardGeneral,
    ActivityCard
  },
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.description
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: `Goa, Goa Tourism, Travel Guide, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Old Goa Churches, Offers, Travel Goa, Visit goa, Car rentals, Bike Rentals, Top things to do in Goa, Travel Agency, places to visit in goa,goa tourism, goa tourist places, best places to visit in goa, goa places, goa best places, must visit places in goa, places to see in goa, goa travel, goa activities, goa itinerary, goa adventure, best tourist places in goa, goa tour guide, goa visit, activities to do in goa, goa adventure activities, goa travel guide, goa travel places, goa guide, see goa, must see places in goa, places to roam in goa, best of goa, best places to see in goa, adventure places in goa, itinerary for goa trip, goa activities to do, best itinerary for goa, best city in goa, goa trip guide, goa trip places, goa tour itinerary, to do in goa, must do in goa, must visit in goa, tourist places to visit in goa, best goa, goa tour places to visit, goa best visit place, goa see, goa to visit places, adventures to do in goa, must see in goa, goa roaming places, best to visit goa, travel itinerary goa, travel for goa, about goa tourist places, tourist activities in goa, places to visit from goa, goa vacation places, best goa trip, goa city tourist places, best city to visit in goa, goa in best places, goa we, goa trip places to visit, holiday places in goa, goa city guide, best place for goa, best places to roam in goa, best goa places to visit, in goa best places, places to in goa, goa trip best places, travel itinerary for goa, goa cities to visit, best adventure places in goa, best places to travel in goa, goa places to roam, itinerary to goa, goa holiday guide, cities in goa to visit, goa places for visit, goa tourism app, best to visit in goa, best tourist places to visit in goa, must visit goa places, do goa, goa in tourist places, best activities to do in goa, in goa best places to visit, goa you, must do activities in goa, best place to roam in goa, best goa tour, places in goa must visit, places you must visit in goa, adventure places to visit in goa, goa best places to see, places to do in goa, www goa tourism places, best place for visit in goa, adventure to do in goa, best goa tourist places, you goa, goa which places to visit, goa best places for visit, the best places to visit in goa, must place to visit in goa, best to do in goa, goa tour goa, best visit in goa, activities in goa for tourists, goa tourism best places to visit, the best goa, goa guided tour, best tourist places of goa, best places in goa for visit, travel and tourism guide, best places to in goa, goa city tour places, guide to goa trip, goa visit guide, the places to visit in goa, places goa to visit, visit to goa places, goa places must visit, the best place to visit in goa, see in goa, must visit goa, we goa, places in goa to roam, to see in goa, goa in place, goa place for visit, goa vacation trip, goa tourism best places, goa to see places, tourism places of goa, goa tourist visit places, must to visit places in goa, best tourist city in goa, goa in best place`
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/meta-imgs/fallback.webp'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.title + " | Goa App"
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/meta-imgs/fallback.webp'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.description
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.title + " | Goa App"
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.description
      }
      ],
      link: [{
        hid: 'canonical',
        rel: 'canonical',
        href: "https://www.goa.app"
      }],
      script: [

      ]
    }
  },
  scrollToTop: true,
  data() {
    return {
      // To store page section data populated from API
      title: "Goa Tourism Travel Guide",
      description: 'Goa App | Discover Beaches, Churches, Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals in Goa.',
      allData: null,
      allDataLoading: true,
      recentlyViewed: null,
      schemaData: [],
      urls: {
        bikeRental: null,
        carRental: null,
        waterSports: null,
        treks: null,
      },
      search: null,
      deviceLoc: null,
      hasPrev: false,
      hasNext: true,
      left: 0,
      originX: 0,
      originLeft: 0,
    };
  },
  jsonld() {
    return this.getJsonData()
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('locationClose'))
      document.getElementById('locationClose').click();
  },
  mounted() {

    //END TYPING
    var locDets = null;
    if (!localStorage.getItem("loc")) {
      setTimeout(() => {
        //document.getElementById('openLoc').click();
      }, 6000);
    } else {
      locDets = JSON.parse(localStorage.getItem("loc"));
      if (locDets.permissionGranted) {
        this.deviceLoc = locDets.locationDets;
        this.requestLoc()
      }
    }

    this.getData()

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('placesFilter')) {
      localStorage.removeItem('placesFilter');
    }
    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    if (localStorage.getItem('blogsFilter')) {
      localStorage.removeItem('blogsFilter');
    }
    if (localStorage.getItem('ticketsFilter')) {
      localStorage.removeItem('ticketsFilter');
    }
    if (localStorage.getItem('reviewsFilter')) {
      localStorage.removeItem('reviewsFilter');
    }
    if (localStorage.getItem('searchFilter')) {
      localStorage.removeItem('searchFilter');
    }
    this.urls.bikeRental = this.$config.bikeRental;
    this.urls.carRental = this.$config.carRental;
    this.urls.waterSports = this.$config.waterSports;
    this.urls.treks = this.$config.treks;
  },

  methods: {
    //##Vue Scroll
    prev() {
      this.$refs.horizontal.prev()
    },
    next() {
      this.$refs.horizontal.next()
    },
    onScrollDebounce({
      hasPrev,
      hasNext
    }) {
      this.hasPrev = hasPrev
      this.hasNext = hasNext
    },
    onScroll({
      left
    }) {
      this.left = left
    },
    onMouseDown(e) {
      this.originX = e.pageX
      this.originLeft = this.left
      window.addEventListener("mouseup", this.onMouseUp);
      window.addEventListener("mousemove", this.onMouseMove);
    },
    onMouseUp() {
      window.removeEventListener("mouseup", this.onMouseUp);
      window.removeEventListener("mousemove", this.onMouseMove);
    },
    onMouseMove(e) {
      const offset = e.pageX - this.originX
      const left = this.originLeft - offset
      this.$refs.horizontal.scrollToLeft(left, 'auto')
    },
    // #End VueScroll
    setInStorage(toStore, locDet = null) {
      let store = {
        permissionGranted: toStore,
        locationDets: locDet,
      }
      localStorage.setItem("loc", JSON.stringify(store));
    },
    requestLoc() {
      var self = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var coords = {
            lat: position.coords.latitude,
            long: position.coords.longitude
          }
          self.deviceLoc = coords;
          self.setInStorage(true, coords)
        },
          function (error) {
            if (error.code == error.PERMISSION_DENIED)
              self.setInStorage(false)
          });
      }
    },
    coordsDets(value) {
      this.deviceLoc = value;
    },
    async getData() {
      this.allData = await fetch(this.$config.fetchUrl + '/api/posts/app/getHomepageData').then(res => res
        .text());
      this.allData = this.getCryptKey(this.allData);
      this.allDataLoading = false;
      this.$nextTick(() => {
        this.allDataLoading = false;
        this.schemaData = this.allData && this.allData.featuredAttractions && this.allData.featuredAttractions
          .length > 0 ? this.allData.featuredAttractions[0].posts : [];
      })
    },

    //To display image of activities
    activitiesImage(image) {
      if (image && image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    getJsonData() {
      if (!this.schemaData) {
        return null
      }
      let structure = {
        "@context": "http://schema.org"
      }
      let data = this.schemaData.map((itm, index) => ({
        "@type": "LocalBusiness",
        "name": itm.title ? itm.title : 'Goa App',
        "image": itm.gallery ? itm.gallery : [],
        "address": {
          "@type": "PostalAddress",
          "streetAddress": itm.city ? itm.city.name : '',
          "addressLocality": "Goa",
          "postalCode": "403001",
          "addressCountry": "IN"
        },
        priceRange: '',
        "review": {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": itm.rating ? itm.rating.averageRating : '',
            "bestRating": itm.rating ? itm.rating.averageRating : '',
          },
          "author": {
            "@type": "Person",
            "name": "GoaApp"
          }
        },
      }))
      let ds = {
        "@graph": data
      }
      return {
        ...structure,
        ...ds
      };
    },

    // STORE ATTRACTION PLACE RESULT IN LOCALSTORAGE
    storePlaceInLS(index, ind) {
      if (this.allData && this.allData.featuredAttractions) {
        let data = {
          postIndex: index,
          attractionIndex: ind,
          allAttractions: this.allData && this.allData.featuredAttractions ? this.allData.featuredAttractions : []
        }
        localStorage.setItem("plcData", JSON.stringify(data));
      }
    },

    eventsPage() {
      this.$router.push('/events');
    },
    activitiesPage() {
      this.$router.push('/activities');
    },
    restaurantsPage() {
      this.$router.push('/offers');
    },
    getRandomNumber(number) {
      let num = number + 1;
      let mod = num % 8
      if (mod < 7) {
        return Math.floor(mod) + 1
      }
      else {
        return mod - 7 != 0 ? mod - 7 : 1;
      }
    }
  }
}
